import React from 'react';
import Header from './Header';

const defaultAspects = {
  mobile: 4 / 3,
  desktop: 12 / 5,
};

const Header2 = props => (
  <Header defaultAspects={defaultAspects} {...props} />
);

export default Header2;
